import { coursePlansApis } from '@shared/apis';
import {
  genericMutation,
  genericMutationWithId,
  genericQuery,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';

export const useListCoursePlans = genericQueryWithParams<coursePlansApis.ListCoursePlans>(
  coursePlansApis.listCoursePlans
);

export const useGetCoursePlan = genericQueryWithId<coursePlansApis.GetCoursePlan>(
  coursePlansApis.getCoursePlan
);

export const useCreateCoursePlan = genericMutation<coursePlansApis.CreateCoursePlan>(
  coursePlansApis.createCoursePlan
);

export const useDeleteCoursePlan = genericMutationWithId<coursePlansApis.DeleteCoursePlan>(
  coursePlansApis.deleteCoursePlan
);

export const useListCoursePlanReviews = genericQuery<coursePlansApis.ListCoursePlanReviews>(
  coursePlansApis.listCoursePlanReviews
);

export const useAddCoursePlanComment = genericMutationWithId<coursePlansApis.AddCoursePlanComment>(
  coursePlansApis.addCoursePlanComment
);

export const useDeleteCoursePlanComment =
  genericMutationWithId<coursePlansApis.DeleteCoursePlanComment>(
    coursePlansApis.deleteCoursePlanComment
  );

export const useRequestCoursePlanUpdate =
  genericMutationWithId<coursePlansApis.RequestCoursePlanUpdate>(
    coursePlansApis.requestCoursePlanUpdate
  );

export const useResolveCoursePlanUpdateRequest =
  genericMutationWithId<coursePlansApis.ResolveCoursePlanUpdateRequest>(
    coursePlansApis.resolveCoursePlanUpdateRequest
  );

export const useApproveCoursePlan = genericMutationWithId<coursePlansApis.ApproveCoursePlan>(
  coursePlansApis.approveCoursePlan
);

export const useReopenCoursePlan = genericMutationWithId<coursePlansApis.ReopenCoursePlan>(
  coursePlansApis.reopenCoursePlan
);
